export default "__VITE_ASSET__Ba4fDVnp__"